import emitPageViewEvent from './emitPageViewEvent';
import emitPartnerUserInteractionEvent from './emitPartnerUserInteractionEvent';
import emitUserInteractionEvent from './emitUserInteractionEvent';
import useActiveProfile from '../useActiveProfile';
import useQueryIntegration from '../useQueryIntegration';
import useRouter from '../useRouter';

type ArgsEmitPageViewEvent = Parameters<typeof emitPageViewEvent>[0];
type ArgsEmitPartnerUserInteractionEvent = Parameters<
  typeof emitPartnerUserInteractionEvent
>[0];
type ArgsEmitUserInteractionEvent = Parameters<
  typeof emitUserInteractionEvent
>[0];

function useAvroEvent() {
  const { params } = useRouter();
  const { appId: integrationId, version: integrationVersion } = params;

  const {
    activeProfile,
    isLoading: isLoadingActiveProfile,
    error: errorActiveProfile,
  } = useActiveProfile();

  const activeProfileId = activeProfile?.id;

  const {
    data: integration,
    isLoading: isLoadingIntegration,
    error: errorQueryIntegration,
  } = useQueryIntegration(
    { integrationId: params.appId },
    { enabled: !!integrationId }
  );

  const isLoading = isLoadingActiveProfile || isLoadingIntegration;
  const error = errorActiveProfile || errorQueryIntegration;

  return {
    emitPageViewEvent: (eventProperties: {
      pagePath: ArgsEmitPageViewEvent['pagePath'];
      urlAddress: ArgsEmitPageViewEvent['urlAddress'];
    }) => {
      if (!isLoading && !error) {
        emitPageViewEvent({ ...eventProperties, userId: activeProfileId });
      }
    },
    emitPartnerUserInteractionEvent: (eventProperties: {
      correlationId: ArgsEmitPartnerUserInteractionEvent['correlationId'];
      eventAction: ArgsEmitPartnerUserInteractionEvent['eventAction'];
      eventId: ArgsEmitPartnerUserInteractionEvent['eventId'];
      interactionGoal: ArgsEmitPartnerUserInteractionEvent['interactionGoal'];
      interactionName: ArgsEmitPartnerUserInteractionEvent['interactionName'];
    }) => {
      if (!isLoading && !error) {
        emitPartnerUserInteractionEvent({
          ...eventProperties,
          accountId: activeProfileId,
          customuserId: activeProfileId,
          integrationId,
          serviceId: integration.serviceId,
        });
      }
    },
    emitUserInteractionEvent: (eventProperties: {
      eventAction: ArgsEmitUserInteractionEvent['eventAction'];
      interactionName: ArgsEmitUserInteractionEvent['interactionName'];
    }) => {
      if (!isLoading && !error) {
        emitUserInteractionEvent({
          ...eventProperties,
          integrationId,
          integrationVersion,
          userId: activeProfileId,
        });
      }
    },
    error,
    isLoading,
  };
}

export default useAvroEvent;
